import { Search } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { SearchModal } from 'screens/blaze/Search/SearchModal/SearchModal'
import { TopBarButton } from './TopBarButton'

export const SearchButton = () => {
  const { openModal } = useModals()

  return <TopBarButton icon={Search} onPress={() => openModal(SearchModal)} />
}
